import { render, staticRenderFns } from "./MenuGroupDrawer.vue?vue&type=template&id=35fd1f0d&scoped=true"
import script from "./MenuGroupDrawer.vue?vue&type=script&lang=js"
export * from "./MenuGroupDrawer.vue?vue&type=script&lang=js"
import style0 from "./MenuGroupDrawer.vue?vue&type=style&index=0&id=35fd1f0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd1f0d",
  null
  
)

export default component.exports